import axios from '@axios'

export interface TableroState {
    links: string[]
}
export default {
    namespaced: true,
    state: {
        links: [],
    },
    getters: {},
    mutations: {},
    actions: {
        async fetchDashboardSettings(_context: unknown, params?: Record<string, unknown>) {
            const response = (await axios.get('api/auth/power-bi', { params }))
            return response
        },
    },
}
